import { PaletteColorOptions, SimplePaletteColorOptions, ThemeOptions } from "@mui/material";
import { ColorPartial } from "@mui/material/styles/createPalette";

const grey = {
    50: "#F2F2F2",
    100: "#E5E5E5",
    200: "#CCCCCC",
    300: "#B2B2B2",
    400: "#999999",
    500: "#7F7F7F",
    600: "#666666",
    700: "#4D4D4D",
    800: "#333333",
    900: "#1A1A1A",
};

export const palette: ThemeOptions['palette'] = {
    primary: {
        main: "#C40109",
        dark: "#A20007",
        light: "#FAE6E7"
    },
    secondary: {
        main: grey[500],
        light: grey[300],
        dark: grey[700],
        contrastText: "#000",
    },
    success: {
        main: '#457907',
        light: '#A0BA51',
    },
    info: {
        main: "#196E9B",
        light: "#E8F0F5",
    },
    warning: {
        main: "#A94B00", // WCAG-safe adjusted orange
    },
    error: {
        main: "#C40109",
        light: "#FAE6E7",
        dark: "#A20007",
    },
    text: {
        primary: '#000',
        secondary: '#4D4D4D',
        disabled: 'rgba(0, 0, 0, 0.38)',
    },
    grey,
    divider: "#E5E5E5",
    common: {
        black: '#000000',
        white: '#FFFFFF',
    },
};

export type PaletteColorOptionsKeys = keyof SimplePaletteColorOptions | keyof ColorPartial;

export const getColorFromPaletteColorOptions = (options: PaletteColorOptions, key: PaletteColorOptionsKeys): string => {
    if (options[key]) {
        return options[key];
    }
    return '';
}